import { FC, SVGAttributes } from 'react';

const StateHelp: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M10.8859 14.5705C10.8859 13.8615 10.972 13.2968 11.1441 12.8765C11.3163 12.4562 11.6303 12.0434 12.0861 11.6383C12.5469 11.2281 12.8533 10.8964 13.0052 10.6432C13.1572 10.3849 13.2331 10.114 13.2331 9.83039C13.2331 8.97455 12.8381 8.54662 12.0481 8.54662C11.6733 8.54662 11.372 8.6631 11.1441 8.89605C10.9213 9.12394 10.8048 9.44045 10.7947 9.84558H8.5918C8.60193 8.87833 8.91337 8.12123 9.52614 7.5743C10.144 7.02737 10.9846 6.75391 12.0481 6.75391C13.1217 6.75391 13.9548 7.01471 14.5473 7.53632C15.1398 8.05287 15.436 8.78464 15.436 9.73164C15.436 10.1621 15.3398 10.5698 15.1474 10.9546C14.9549 11.3345 14.6182 11.7573 14.1371 12.2232L13.5218 12.8081C13.1369 13.1778 12.9166 13.6108 12.8609 14.1071L12.8305 14.5705H10.8859Z"
        fill="currentColor"
      />
      <path
        d="M10.6656 16.9025C10.6656 16.5632 10.7795 16.2847 11.0074 16.0669C11.2404 15.8441 11.5366 15.7327 11.8962 15.7327C12.2557 15.7327 12.5494 15.8441 12.7773 16.0669C13.0103 16.2847 13.1268 16.5632 13.1268 16.9025C13.1268 17.2367 13.0128 17.5127 12.7849 17.7305C12.5621 17.9483 12.2659 18.0571 11.8962 18.0571C11.5265 18.0571 11.2277 17.9483 10.9998 17.7305C10.777 17.5127 10.6656 17.2367 10.6656 16.9025Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM20.5 12.5C20.5 17.1944 16.6944 21 12 21C7.30558 21 3.5 17.1944 3.5 12.5C3.5 7.80558 7.30558 4 12 4C16.6944 4 20.5 7.80558 20.5 12.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StateHelp;
